import script from "./AddCourse.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCourse.vue?vue&type=script&setup=true&lang=js"

import "./AddCourse.vue?vue&type=style&index=0&id=b0179f26&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0179f26"]])

export default __exports__